import { styled, TableCell, TableContainer } from '@mui/material';

const TABLE_BORDER_COLOR = '#737F86';

const StyledContainer = styled(TableContainer)(({ theme }) => ({
  border: `1px solid ${TABLE_BORDER_COLOR}`,
  borderRadius: '4px',
  width: 'fit-content',
}));

const StyledCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.875rem',
  padding: '8px 16px',
  borderRight: `1px solid ${TABLE_BORDER_COLOR}`,
  borderBottom: `1px solid ${TABLE_BORDER_COLOR}`,
  '&:last-child': { borderRight: 'none' },
}));

export { StyledContainer, StyledCell };
